import { Component } from '@angular/core';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-soft-ban-modal',
  templateUrl: './soft-ban-modal.component.html',
  styleUrls: ['./soft-ban-modal.component.scss'],
})
export class SoftBanModalComponent {
  constructor(
    private utilityService: UtilityService,
    protected modalCtrl: ModalController,
  ) {}

  /**
   * Open web link for terms of use.
   *
   * @param link
   */
  openLink(link: string): void {
    this.utilityService.openExternalLink(`${link}`, '_system');
  }

  /**
   * For closing modal window.
   *
   * @param returnedValue - The value to be returned after modal is closed.
   * @returns value from above.
   */
  closeModal(): Promise<boolean> {
    return this.modalCtrl.dismiss();
  }
}
